import React from 'react';
import { Mode } from '@/constants/Mode';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

interface ITrustBox {
  mode: Mode | string;
}

export const TrustBoxUI = ({ mode }: ITrustBox) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);

  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <>
      {mode === Mode.LIGHT && (
        <div
          ref={ref} // We need a reference to this element to load the TrustBox in the effect.
          className="trustpilot-widget"
          data-locale="en-AU"
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id="5c08b592390696000193c25d"
          data-style-height="95px"
          data-style-width="100%"
          data-theme="light"
          data-font-family="Roboto"
          data-text-color="#141415"
        >
          <a href="https://au.trustpilot.com/review/athena.com.au" target="_blank" rel="noopener noreferrer">
            Trustpilot
          </a>
        </div>
      )}
      {mode === Mode.DARK && (
        <div
          ref={ref} // We need a reference to this element to load the TrustBox in the effect.
          className="trustpilot-widget"
          data-locale="en-AU"
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id="5c08b592390696000193c25d"
          data-style-height="95px"
          data-style-width="100%"
          data-theme="dark"
          data-font-family="Roboto"
          data-text-color="#ffffff"
        >
          <a href="https://au.trustpilot.com/review/athena.com.au" target="_blank" rel="noopener noreferrer">
            Trustpilot
          </a>
        </div>
      )}
    </>
  );
};
